import { useRecruitmentApi } from 'infrastructure/api';
import { useState } from 'react';
import { copyByNavigator } from 'framework/ui/clipboard';
import { FormFieldsData } from 'framework/form';

const DAVINCI_CANDIDATE_PUBLIC = process.env.REACT_APP_DAVINCI_CANDIDATE_PUBLIC_FRONTEND_URL;
const INTERVIEW_SCHEDULING_PATH = '/interview-scheduling';

const useInterviewSchedulerLink = (currentApplicationId: number) => {
  const [isLoading, setLoading] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const { sendPostRequest } = useRecruitmentApi();

  const copyAction = async (hash: string) => {
    try {
      await copyByNavigator(`${DAVINCI_CANDIDATE_PUBLIC}${INTERVIEW_SCHEDULING_PATH}/${hash}`);
      setIsCopied(true);
      setTimeout(() => {
        setIsCopied(false);
      }, 4000);
    } catch (err) {
      throw new Error('Clipboard error!');
    }
  };

  const getLink = async (requestData?: FormFieldsData) => {
    const { interviewers = [], isAdditional = false, timeslotDuration = null } = requestData || {};
    try {
      setLoading(true);

      const responce = await sendPostRequest('/interviews/link', {
        applicationId: currentApplicationId,
        specifiedInterviewers: interviewers?.map((item: { value: string }) => item.value),
        isAdditional,
        timeslotDuration,
      });

      const data = await responce.json();
      setLoading(false);

      return data.interviewLinkToken;
    } catch (error) {
      setLoading(false);
      throw new Error('Something went wrong.');
    }
  };

  return {
    setLoading,
    isLoading,
    getLink,
    isCopied,
    copyAction,
  };
};

export default useInterviewSchedulerLink;
